<span class="icc-select-wrapper" [class.has-value]="value || treatDefaultOptionAsValue" [class.focused]="focused">
    <span class="icc-select-frame">
        <span
        *ngIf="prefixIcon"
        class="icc-select-prefix-icon"
        >
            <icc-icon [name]="prefixIcon"></icc-icon>
        </span>
        <label *ngIf="label" class="icc-select-label">{{ label }}</label>
        <select
            [attr.disabled]="disabled ? true : null"
            [attr.required]="required ? true : null"
            [class.ng-invalid]="isInvalid()"
            [class.ng-valid]="isValid()"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            #select
        >
            <ng-content></ng-content>
        </select>
    </span>
    <span
        *ngIf="supportTextIsVisible"
        class="icc-select-footer"
    >
        <span
            class="icc-select-support-tekst"
        >
            {{supportText}}
        </span>
    </span>
</span>
